<template>
    <div class="share">
        <share-item v-for="(n,i) in lists" :key="i" :share="n" ></share-item>
    </div>
</template>

<script>
import shareItem from "../../components/endPage/shareItem";

export default {
  name: "share",
  data() {
    return {
      lists: []
    };
  },
  components: {
    shareItem
  },
  inject: ["showMsg"],
  created() {
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "footerNav[6]");
    this.getShareList();
  },
  methods: {
    getShareList() {
      this.$http({
        method: "post",
        url: this.weburl + "/home/Other/getInform",
        dataType: "json",
        data: {
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.lists = res.data.result;
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    }
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common";
.share {
  .media;
  background: @bg;
  padding: 1rem 1rem 1px;
}
</style>
